module.exports = __webpack_public_path__ + "static/media/18impuesto.ad256d1.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/18impuesto.mp4
// module id = 723
// module chunks = 1